<div class="printable">
  <authority-labs-base-certificate-details
    [order]="order"
    [project]="project"
    [subProject]="subProject"
    [company]="company"
    [contact]="contact"
    [assignee]="assignee"
    [approval]="approval"
    [inspection]="inspection"
    [systemDescription]="'גלגילונים לכיבוי אש'"
  ></authority-labs-base-certificate-details>

  <div class="page-break"></div>

  <authority-labs-fire-extinguishers-test-results
    [inspection]="inspection.inspectionFireExtinguishers"
  >
  </authority-labs-fire-extinguishers-test-results>

  <p style="text-align: center">
    <strong style="font-size: 5pt; position: relative; top: -5px"
      >&#10033;</strong
    >
    <strong style="font-size: 14pt">סוף תעודת בדיקה</strong>
    <strong style="font-size: 5pt; position: relative; top: -5px"
      >&#10033;</strong
    >
  </p>
</div>
